<template>
<div class="home main">
    <header class="home-head">
        <img class="home-head-left" src="@/assets/imgs/avatar_def.png">
        <div class="home-head-mid">
            <div>{{userInfo.anotherName}}<span class="home-head-editPwd" @click="hanleEditPwd">修改密码</span> <span class="home-head-exit" @click="hanleExit">退出</span></div>
            <div>欢迎登录！您上次登录的时间为：{{userInfo.lastLoginTime}}</div>
        </div>
        <div class="home-head-right">
            <div>
                {{nowDate}} {{nowWeek}}
            </div>
            <div class="home-head-time">{{nowTime}}</div>
        </div>
    </header>
    <div class="home-line"></div>
    <div class="menu-1">
        <div class="menu-row" @click="clickMenu('/whiteList')">
            <img class="menu-icon" src="@/assets/imgs/xx2.png" />
            白名单客户管理
        </div>
        <!-- 核销相关 临时关闭 -->
        <!-- <div class="menu-row" @click="clickMenu('/recordList')">
            <img class="menu-icon" src="@/assets/imgs/xx1.png" />
            核销记录管理
        </div> -->
    </div>

    <div class="menu">
        <div class="menu-row2">
            账户余额:<span class="menu-row2-s">{{amountData.accountBalance}}</span>元
        </div>
        <div class="menu-row2">
            派券金额:<span class="menu-row2-s">{{amountData.countGrantBalance}}</span>元
        </div>
        <!-- 核销相关 临时关闭 -->
        <!-- <div class="menu-row2">
            已核销金额:<span class="menu-row2-s">{{amountData.countClearBalance}}</span>元
        </div> -->
    </div>

    <!-- 修改密码 -->
    <el-dialog title="修改密码" :visible.sync="dialogFormVisible" width="540px">
        <div>密码需由字母和数字组合，允许使用符号，长度在6-16字符之间。</div>
        <el-form :model="form" ref="ruleForm" :rules="rules" label-width="120px">
            <el-form-item label="原密码" prop="oldPassword">
                <el-input type="password" v-model.trim="form.oldPassword" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="新密码" prop="newPassword">
                <el-input type="password" v-model.trim="form.newPassword" auto-complete="off"></el-input>
            </el-form-item>
            <div class="pretendRequired">
                <el-form-item label="确认密码" prop="reNewPassword">
                    <el-input type="password" v-model.trim="form.reNewPassword" auto-complete="off"></el-input>
                </el-form-item>
            </div>
            <el-form-item prop="inputRandomCode" label="验证码">
                <div class="sp-row">
                    <el-input style="width:40%" type="text" v-model="form.inputRandomCode" auto-complete="on" placeholder="">
                        <i slot="prefix" class="icon-number"></i>
                    </el-input>
                    <img class="imgCode" @click="getCodeImg" :src="imgCodeUrl" />
                </div>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false">取 消</el-button>
            <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
        </div>
    </el-dialog>
</div>
</template>

<script>
import {
    rap,
    fetch,
    removeCookie
} from "@/utils/common.js";

let url = {
    profile: "/fep/pc/marketingUserAdmin/getUserMessage",
    changePassword: '/fep/pc/marketingUserAdmin/updatePassword',
    imgCode: "/fep/pc/marketingUserAdmin/img",
    amount: "/fep/pc/marketingUserAdmin/clearMoney",
    outLogin: "/fep/pc/marketingAdminLogin/logout"
};
let timer = null;
export default {
    components: {},
    props: [],
    data() {
        let checkPassword = (rule, value, callback) => {
            if (!value) {
                return callback(new Error('请再一次输入新密码'))
            } else {
                if (this.form.newPassword !== this.form.reNewPassword) {
                    return callback(new Error('新密码与确认密码不相同'))
                } else {
                    callback()
                }
            }
        }
        return {
            imgCodeUrl: url.imgCode,
            userInfo: {},
            amountData: {},
            nowWeek: '',
            nowDate: '',
            nowTime: '',
            tLoading: true,
            total: 0,
            pageNo: 1,
            pageSize: 10,
            totalPage: 0,
            tableData: [],
            multipleSelection: [],
            dealTime: "",
            dialogFormVisible: false,
            rules: {
                oldPassword: [{
                    required: true,
                    message: '请输入原密码',
                    trigger: 'blur'
                }],
                newPassword: [{
                    required: true,
                    message: '请输入新密码',
                    trigger: 'blur'
                }],
                reNewPassword: [{
                    validator: checkPassword,
                    trigger: 'change'
                }],
                inputRandomCode: [{
                    required: true,
                    message: '请输入验证码',
                    trigger: 'blur'
                }, ]
            },
            form: {
                oldPassword: '',
                newPassword: '',
                reNewPassword: '',
                inputRandomCode: ''
            },

        };
    },
    computed: {},
    watch: {},
    created() {
        timer = setInterval(() => {
            this.setNowTimes()
        }, 1000)
        
        setInterval(() => {
            this.getAmount()
        }, 10000);
    },
    mounted() {
        fetch(url.profile).then((res) => {
            this.userInfo = res.data
        });

        this.getAmount()

        // this.getList();
    },
    methods: {
        getAmount() {
            fetch(url.amount).then((res) => {
                this.amountData = res.data
            });
        },
        hanleEditPwd() {
            this.dialogFormVisible = true
            this.form.oldPassword = ''
            this.form.newPassword = ''
            this.form.reNewPassword = ''
        },
        hanleExit() {
            fetch(url.outLogin, {}).then((res) => {
                this.$router.replace('/login')
            })
            // removeCookie('igs_ccb_user_token')
        },
        getCodeImg() {
            this.imgCodeUrl = url.imgCode + "?i=" + Math.random()
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    //alert('submit!')
                    this.fetchChangePassword()
                } else {
                    console.log('error submit!!')
                    return false
                }
            })
        },
        fetchChangePassword() {
            fetch(url.changePassword, this.form).then(res => {
                if (res.status === 200) {
                    this.$message({
                        message: res.message,
                        type: 'success'
                    })
                }
                this.dialogFormVisible = false
                this.$router.replace({
                    path: '/login'
                })
            })
        },
        clickMenu(path) {
            this.$router.push(path)
        },
        setNowTimes() {
            let myDate = new Date()
            // console.log(myDate)
            let wk = myDate.getDay()
            let yy = String(myDate.getFullYear())
            let mm = myDate.getMonth() + 1
            let dd = String(myDate.getDate() < 10 ? '0' + myDate.getDate() : myDate.getDate())
            let hou = String(myDate.getHours() < 10 ? '0' + myDate.getHours() : myDate.getHours())
            let min = String(myDate.getMinutes() < 10 ? '0' + myDate.getMinutes() : myDate.getMinutes())
            let sec = String(myDate.getSeconds() < 10 ? '0' + myDate.getSeconds() : myDate.getSeconds())
            let weeks = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
            let week = weeks[wk]
            this.nowDate = yy + '/' + mm + '/' + dd
            this.nowTime = hou + ':' + min + ':' + sec
            this.nowWeek = week
        }
    },
};
</script>

<style lang="scss" scoped>
#app {
    overflow: auto !important;
}

.main {
    width: 1000px;
    padding: 20px;
    margin: 30px auto 30px;
    border: 1px solid #f7f7f7;
    background: #fcfcfc;
    box-shadow: 0px 0px 10px -6px #888888;
}

.home {
    .home-head {
        display: flex;
        align-items: center;
        font-size: 18px;
    }

    .home-head-left {
        width: 60px;
        height: 60px;
    }

    .sp-row {
        display: flex;
        align-items: center;
    }

    .imgCode {
        width: 80px;
        height: 35px;
        background: #cccccc;
        margin-left: 15px;
    }

    .home-head-right {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
    }

    .home-head-time {
        font-weight: bold;
        font-size: 19px;
    }

    .home-head-mid {
        flex: 1;
        margin: 0 20px;
    }

    .home-head-editPwd {
        color: #F18800;
        font-size: 14px;
        margin-left: 20px;
        text-decoration: underline;
        cursor: pointer;
    }

    .home-head-exit {
        color: #e43630;
        font-size: 14px;
        margin-left: 30px;
        cursor: pointer;
    }

    .home-line {
        margin-top: 20px;
        background: #e2e1e1;
        height: 2px;
        width: 1000px;
        flex: 1;
    }

    .menu-1 {
        display: flex;
        justify-content: center;
        margin-top: 20px;
    }

    .menu {
        display: flex;
        justify-content: space-between;
        margin-top: 20px;
    }

    .menu-row {
        display: flex;
        background: #ffffff;
        border: 1px solid #eeeeee;
        width: 380px;
        height: 80px;
        justify-content: center;
        align-items: center;
        font-size: 20px;
        font-weight: 500;
    }

    .menu-row2 {
        display: flex;
        width: 380px;
        height: 80px;
        justify-content: center;
        align-items: center;
        font-size: 24px;
    }

    .menu-row2-s {
        color: #F18800;
        margin: 0 5px;
    }

    .el-form-item__label {
        color: #888;
        padding-right: 8px;
        white-space: normal !important;
    }

    .d-sel {
        color: rgb(223, 217, 217);
    }

    .menu-icon {
        width: 22px;
        height: 22px;
        margin-right: 10px;
    }
}
</style>
